import { LoanTerms } from './types';
/* eslint-disable @typescript-eslint/naming-convention */
export const creditTiers = {
  '740+': 740,
  '700-739': 700,
  '660-699': 660,
  '620-659': 620,
  '580-619': 580,
  '579 or less': 579
} as const;

export const interestRateToCreditTiers = {
  740: 6.625,
  700: 6.99,
  660: 7,
  620: 7,
  580: 7,
  579: 7
} as const;

export const loanTermsOptions = [
  { value: LoanTerms.THIRTY, title: '30 years fixed' },
  { value: LoanTerms.TWENTY, title: '20 years fixed' },
  { value: LoanTerms.FIFTEEN, title: '15 years fixed' }
];
